<script lang="ts" setup>
// Navigation en tiroir, ouverte par le bouton menu de `HeaderBrand` sous `md`.
import {
  HEADER_MENUS_PRIMAIRES,
  HEADER_MENUS_SECONDAIRES,
} from '~/utils/headerMenus'

const open = defineModel<boolean>('open', { required: true })

function close() {
  open.value = false
}
</script>

<template>
  <Transition name="fade">
    <div
      v-if="open"
      class="fixed inset-0 z-50 bg-black/90 flex"
      @click.self="close"
    >
      <div class="bg-white w-4/5 max-w-xs h-full shadow-xl p-4 flex flex-col overflow-y-auto">
        <div class="flex justify-between items-center mb-6">
          <HeaderLogo class="w-32" />
          <button aria-label="Fermer le menu" @click="close">
            <Icon name="lucide:x" class="text-2xl" />
          </button>
        </div>
        <div class="flex flex-col gap-2">
          <NuxtLink
            v-for="menu in HEADER_MENUS_PRIMAIRES"
            :key="menu.name"
            :to="menu.href"
            class="flex items-center px-2 py-3 text-black hover:bg-primary hover:text-white rounded transition text-base"
            @click="close"
          >
            <Icon :name="menu.icon" class="text-lg mr-3" />
            {{ menu.name }}
          </NuxtLink>
          <div class="mt-4">
            <p class="font-bold mb-2">
              Autres
            </p>
            <NuxtLink
              v-for="item in HEADER_MENUS_SECONDAIRES"
              :key="item.name"
              :to="item.href"
              class="flex items-center px-2 py-2 text-gray-700 hover:bg-primary hover:text-white rounded transition"
              @click="close"
            >
              <Icon :name="item.icon" class="mr-2" />
              {{ item.name }}
            </NuxtLink>
            <hr class="border-black border-1 my-4">
            <HeaderContactLinks />
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
